import { render, staticRenderFns } from "./UserAddress1.vue?vue&type=template&id=d94fe086&"
import script from "./UserAddress1.vue?vue&type=script&lang=js&"
export * from "./UserAddress1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports